import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Card, CardBody } from 'reactstrap';
import { Plus, Layers, Globe } from 'react-feather';
import { toast } from 'react-toastify';

import SitegroupDetailsInSites from './SitegroupDetailsInSites';

import useOrgIdentifer from '@hooks/org_identifier';

export default function AllSites({ current_organization, current_user, take_my_org_details }) {
  const history = useHistory();
  const org_identifier = useOrgIdentifer();

  useEffect(() => {
    take_my_org_details(org_identifier);
  }, [org_identifier]);

  useEffect(() => {
    if (org_identifier === 'promptcloud') {
      history.push('/');
      toast.error('You are not authorized this page');
    }
  }, [org_identifier]);

  return (
    <Container fluid>
      {/* Header card with title + actions */}
      <Card className='shadow-sm border-0 mb-3'>
        <CardBody className='d-flex align-items-center justify-content-between flex-wrap' style={{ padding: '20px 24px', gap: 12 }}>
          <div className='d-flex align-items-center' style={{ gap: 14, minWidth: 0 }}>
            <div
              className='d-inline-flex align-items-center justify-content-center flex-shrink-0'
              style={{ width: 44, height: 44, borderRadius: 10, background: '#0d6efd15', color: '#0d6efd' }}
            >
              <Globe size={22} />
            </div>
            <div style={{ minWidth: 0 }}>
              <h5 className='mb-1 text-dark fw-semibold' style={{ fontSize: 18 }}>
                Site Status
              </h5>
              <p className='text-muted mb-0' style={{ fontSize: 13 }}>
                Manage your site groups, view crawl schemas, and track delivery status.
              </p>
            </div>
          </div>
          <div className='d-flex' style={{ gap: 8 }}>
            <a
              href={`/organizations/${org_identifier}/site/add`}
              className='btn btn-outline-primary d-inline-flex align-items-center'
              style={{ fontSize: 13 }}
            >
              <Plus size={14} className='me-1' />
              Add Site
            </a>
            <a
              href={`/organizations/${org_identifier}/sites/new`}
              className='btn btn-primary d-inline-flex align-items-center'
              style={{ fontSize: 13 }}
            >
              <Layers size={14} className='me-1' />
              Add Site Group
            </a>
          </div>
        </CardBody>
      </Card>

      <SitegroupDetailsInSites orgName={org_identifier} current_organization={current_organization} />
    </Container>
  );
}
